import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const displayModes = ["角色成员", "角色权限", "数据范围"];

const initState = {
    rolesLoading: false, // 角色列表加载
    roles: [], // 角色列表
    checkedRole: { // 选中的角色列表
        id: null,
        name: "",
        roleType: "",
        description: "",
        defaultRole: true,
        dataPermission: null,
    },
    editRole: null, // 新增/编辑角色
    editRoleSaving: false, // 新增/编辑角色保存中
    displayMode: displayModes[0], // 展示页面

    searchValue: "", // 姓名检索
    membersLoading: false, // 角色成员加载
    membersPageable: { // 角色成员查询分页
        total: 0,
        offset: 0,
        limit: 30,
    },
    allMembers: [], // 所有成员
    members: [], // table显示的角色成员，过滤后
    addMemberModalVisible: false, // 添加人员弹窗
    employeeTreeLoading: false, // 待选人员加载
    employeeTree: [], // 待选人员
    keyword: "", // 检索待选人员
    checkedUsers: [], // 此次选中的人员
    addMemberModalSaving: false, // 添加人员保存
    removeCheckedUsers: [], // 删除人员选中

    permissionsLoading: false, // 角色权限加载
    allPermissionGroups: [], // 所有权限分组
    rolePermissions: [], // 角色拥有的权限

    editMember: null, // 待编辑成员信息
    editPermUnits: [], // 待编辑的成员数据范围
    editMemberSaving: false, // 角色设置弹窗保存
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    displayModes,
};

export default viewModel;
